export const RHAs = [
    {
        "name": "Samy Martinez",
        "email": "sm201@rice.edu",
        "year": "Senior",
    },
    {
        "name": "Christina Ko",
        "email": "cyk3@rice.edu",
        "year": "Senior",
    },
    {
        "name": "Daniel Peinado",
        "email": "drp5@rice.edu",
        "year": "Senior",
    },
    {
        "name": "Melissa Lee",
        "email": "melissalee@rice.edu",
        "year": "Senior",
    },
    {
        "name": "Katie Maurano",
        "email": "km78@rice.edu",
        "year": "Senior",
    },
    {
        "name": "Navya Dronamraju",
        "email": "nd58@rice.edu",
        "year": "Junior",
    },
    {
        "name": "Lauren Light",
        "email": "lyl1000@rice.edu",
        "year": "Junior",
    },
    {
        "name": "Ayra Matondang",
        "email": "asm20@rice.edu",
        "year": "Senior",
    },
    {
        "name": "Arcadia Hinton-Cooley",
        "email": "arh8@rice.edu",
        "year": "Senior",
    },
    {
        "name": "Abigail Li",
        "email": "al181@rice.edu",
        "year": "Junior",
    },
    {
        "name": "Shivani Patel",
        "email": "sp225@rice.edu",
        "year": "Sophomore",
    },
    {
        "name": "Paloma Kimball",
        "email": "pk65@rice.edu",
        "year": "Sophomore",
    },
    {
        "name": "Manja Lund",
        "email": "pk65@rice.edu",
        "year": "Senior",
    },
]